export default __webpack_public_path__ + "static/media/grid.f1a133c5.svg";